const PrizeType = {
  // Định danh
  id: null,
  code: "",
  cp_id: null,
  // Hiển thị (3 field duy nhất component này đọc)
  name: "",
  image: null,
  price: 0,
  start_price: 0,
  // Khung giờ đấu
  start_time: null,
  end_time: null,
  // Trạng thái
  status: null,
  count_user: null,
  create_time: null,
  update_time: null,
};

export default PrizeType;
